import { css } from "@emotion/css";
import { BorderRadius, Colors, Spacing } from "@snapchat/snap-design-system";

export const visibilityTrigger = css`
    min-width: 200px;
    height: 56px;

    &.sds-base-button.ant-btn {
        display: flex;
        justify-content: space-between;

        padding: ${Spacing.SM}px;

        background-color: ${Colors.Gray.V50};
        border-radius: ${BorderRadius.checkbox}px;
        box-shadow: none;

        &:hover,
        &:focus {
            box-shadow:
                0 0 0 2px ${Colors.Yellow.V200},
                0 2px 12px rgba(255, 211, 1, 24%);
        }

        .sds-icon-chevron-down {
            margin-right: ${Spacing.XS}px;
        }
    }
`;
